import moment from 'moment-timezone';

import { formatDate, iaRa } from 'lib/helpers/utility';

export const formatDateHeader = (dateString, timezone) => {
  if (!dateString) return '';
  const now = timezone ? moment.tz(timezone) : moment();
  const dateToFormat = timezone ? moment.tz(dateString, timezone) : moment(dateString);
  const diffInDays = now.diff(dateToFormat, 'days');

  if (diffInDays === 0) {
    return 'Today';
  }

  if (diffInDays === 1) {
    return 'Yesterday';
  }

  return formatDate(dateString, timezone, false, 'MMMM D, YYYY');
};

export const groupActivitiesByDate = (activities, timezone) => {
  const grouped = {};
  const dateKeys = [];

  iaRa(activities).forEach((activity) => {
    const dateKey = formatDate(activity.created_at, timezone);

    if (!dateKey) return;

    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
      dateKeys.push(dateKey);
    }
    grouped[dateKey].push(activity);
  });

  // Sort date keys in ascending order (oldest first)
  // Parse dates to compare properly (MM/DD/YYYY format)
  dateKeys.sort((a, b) => {
    const dateA = moment(a, 'MM/DD/YYYY');
    const dateB = moment(b, 'MM/DD/YYYY');
    return dateA.valueOf() - dateB.valueOf();
  });

  return { grouped, dateKeys };
};
